<template>
  <div class="header" id="balance">
    <div class="content">
      <ul v-for="item in blist" :key="item.id">
        <li>
          <p class="price">{{item.available}}</p>
          <p>自由积分</p>
          <p class="added">（含授信余额）</p>
        </li>
        <li>
          <p class="price">{{item.shoppingamount}}</p>
          <p>购物积分</p>
        </li>
        <li>
          <p class="price">{{item.credit}}</p>
          <p>授信余额</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeBalance',
  props: {
    blist: Array
  }
}
</script>

<style scoped>
.header{ padding: 10px 15px; padding-top: 0; border-bottom: 12px solid #f1f1f1;}
.content ul{ display: flex; justify-content: space-between; text-align: center; margin-top: 30px; padding-bottom: 10px;}
.content p{ color: #3a3633; font-size: 14px;}
.content .price{ color: #db2528;}
.content .added{ font-size: 12px; color: #6c6662;}
li{ list-style-type: none;}
</style>



// WEBPACK FOOTER //
// src/pages/me/components/Balance.vue